import React from 'react';
import {
  colors,
  fontSizes,
  fontWeights,
  fonts,
  lineHeights,
} from '../../../config/theme/tokens';
import { Typography } from '@mui/material';

type TitleProps = {
  className?: string;
  fontSize?: keyof typeof fontSizes;
  fontWeight?: keyof typeof fontWeights;
  color?: keyof typeof colors;
  lineHeight?: keyof typeof lineHeights;
  children: React.ReactNode | string;
};

export const Title: React.FC<TitleProps> = ({
  className,
  fontSize = 'md',
  fontWeight = 'regular',
  color = 'neutral70',
  lineHeight,
  children,
}) => {
  const setterFontFamily =
    fontWeight === 'grand-heavy' ? fonts.default_grand_heavy : fonts.default;

  if (lineHeight) {
    return (
      <Typography
        fontFamily={setterFontFamily}
        fontStyle='normal'
        fontSize={fontSizes[fontSize]}
        fontWeight={fontWeights[fontWeight]}
        color={colors[color]}
        lineHeight='120%'
        className={`leading-[120%] ${className}`}
      >
        {children}
      </Typography>
    );
  }

  return (
    <Typography
      fontFamily={setterFontFamily}
      fontSize={fontSizes[fontSize]}
      fontWeight={fontWeights[fontWeight]}
      color={colors[color]}
      className={`leading-[120%] ${className}`}
      lineHeight='120%'
    >
      {children}
    </Typography>
  );
};
